import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type BorderSize = 'default' | 'wide';

const BORDER_SIZE: Record<BorderSize, number> = {
    default: 1,
    wide: 3,
};

interface RAvatarProps {
    imageUrl?: string | null;
    initials: string;
    size?: number;
    color?: string;
    borderSize?: BorderSize;
    onClick?: () => void;
}

export function RAvatar({ imageUrl, initials, size = 44, color, borderSize = 'default', onClick }: RAvatarProps) {
    const fontSize = Math.round(size * 0.32);
    const hasImage = !!imageUrl;

    return (
        <Container
            onClick={onClick}
            style={{
                width: size,
                height: size,
                fontSize,
                backgroundColor: hasImage ? undefined : color ?? Colors.lightGrey,
                color: color ? Colors.white : Colors.darkNavy,
                border: hasImage ? `${BORDER_SIZE[borderSize]}px solid ${color ?? Colors.mediumGrey}` : undefined,
                cursor: onClick ? 'pointer' : 'default',
            }}
        >
            {hasImage ? <Image src={imageUrl} alt={initials} /> : initials}
        </Container>
    );
}

const Container = styled('div')({
    borderRadius: '50%',
    backgroundColor: Colors.lightGrey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    color: Colors.darkNavy,
    position: 'relative',
    overflow: 'visible',
    flexShrink: 0,
});

const Image = styled('img')({
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
});
